import type { ReactNode } from 'react';

import {
  ToastRackProvider as Provider,
  useToasty,
} from '@shieldpay/toast-rack-provider-ui';

import { Box } from '../box/box';

import { Notification } from './notification';

import * as styles from './toast-rack.css';

interface ToastRackProviderProps {
  children: ReactNode;
  characterTimeMultiplier?: number;
}

const CHARACTER_TIME_MULTIPLIER = 100;

const Wrapper = ({ children }: { children: ReactNode }) => (
  <Box
    className={styles.toastRack}
    spacing="basePos1"
    alignContent={{ x: 'center', y: 'bottom' }}
    padding={{ bottom: 'basePos6' }}
  >
    {children}
  </Box>
);

export const ToastRackProvider = ({
  children,
  characterTimeMultiplier = CHARACTER_TIME_MULTIPLIER,
}: ToastRackProviderProps) => {
  return (
    <Provider
      Wrapper={Wrapper}
      Notification={Notification}
      characterTimeMultiplier={characterTimeMultiplier}
    >
      {children}
    </Provider>
  );
};

export { useToasty };
